interface RatingBadgeProps {
  rating: number;
  source: string | null;
  size?: 'sm' | 'lg';
  className?: string;
}

const SOURCE_STYLES: Record<string, { label: string; bg: string; text: string; star: string }> = {
  bgg: { label: 'BGG', bg: 'bg-yellow-50', text: 'text-yellow-700', star: 'text-yellow-500' },
  local: { label: 'LT', bg: 'bg-green-50', text: 'text-green-700', star: 'text-green-500' },
  ai: { label: 'AI', bg: 'bg-purple-50', text: 'text-purple-700', star: 'text-purple-500' },
};

const SIZES = {
  sm: { wrapper: 'rounded-full px-2 py-0.5 text-xs gap-0.5', icon: 'h-3 w-3', label: 'ml-0.5 text-[10px] font-medium opacity-75' },
  lg: { wrapper: 'rounded-xl px-4 py-2 gap-2', icon: 'h-5 w-5', label: 'text-sm opacity-75' },
};

export function RatingBadge({ rating, source, size = 'sm', className = '' }: RatingBadgeProps) {
  const style = source ? SOURCE_STYLES[source] : SOURCE_STYLES.bgg;
  const s = style ?? SOURCE_STYLES.bgg;
  const sz = SIZES[size];

  return (
    <span
      className={`inline-flex items-center ${sz.wrapper} ${s.bg} ${s.text} ${className}`}
    >
      <svg
        className={`${sz.icon} ${s.star}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
      <span className={size === 'lg' ? 'text-lg font-bold' : ''}>
        {rating.toFixed(1)}
      </span>
      <span className={sz.label}>
        {s.label}
      </span>
    </span>
  );
}
